import { render, staticRenderFns } from "./ProjectAdded.vue?vue&type=template&id=eb2ee562&"
import script from "./ProjectAdded.vue?vue&type=script&lang=ts&"
export * from "./ProjectAdded.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports